import { useCallback, useEffect, useRef, useState } from 'react';
import { api, errorText, useWorkspace } from './workspace';

// Read-only UI polling. Engine scheduling lives entirely in the authenticated backend cron.
export function usePaperEngine() {
  const { user } = useWorkspace();
  const [state, setState] = useState<any>(null), [error, setError] = useState(''), [loading, setLoading] = useState(false);
  const version = useRef<number | null>(null); const inFlight = useRef(false);
  const reload = useCallback(async () => {
    if (!user || inFlight.current) return;
    inFlight.current = true; setLoading(true);
    try { const r = await api.get('/crypto/engine/status'); setState(r.data); setError('');
      const next = r.data.wallet.version;
      if (version.current !== null && version.current !== next) window.dispatchEvent(new Event('qe-data-changed'));
      version.current = next;
    } catch (e) { setError(errorText(e)); } finally { inFlight.current = false; setLoading(false); }
  }, [user]);
  useEffect(() => {
    setState(null); setError(''); version.current = null;
    if (!user) return;
    reload(); const timer = setInterval(reload, 3000); const listener = () => { reload(); };
    window.addEventListener('qe-engine-changed', listener);
    return () => { clearInterval(timer); window.removeEventListener('qe-engine-changed', listener); };
  }, [user, reload]);
  return { state, error, loading, reload };
}